<template>
	<div class="italic">ƒ {{ value.data.name }}()</div>
</template>

<script>
export default {
	name: 'ArgFunction',
	props: {value: Object},
}
</script>
